import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class PlushieAlertAssignment implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;

  constructor(
    private fId: string,
    private fPlushie: string,
    private fAlert: string
  ) {
    [fId, fPlushie, fAlert].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get plushie(): string {
    return this.fPlushie;
  }

  get alert(): string {
    return this.fAlert;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }
}
